<template>
  <v-row>
    <v-col lg="4" cols="12">
      <ProfileCard :user="authUser"/>
      <v-card class="mt-3 pa-4" id="payment-card">
        <small v-if="authUser.subscription_plan" class=""
          >You have been subscribed
          <b
            >${{ authUser.subscription_plan.price/100 }} per
            {{ authUser.subscription_plan.interval }}</b
          ></small
        >
      </v-card>
    </v-col>
    <v-col lg="8" cols="12">
      <AddPost
        :handleSubmit="(data) => addPost(data)"
        :loading="postLoading"
        :notification="postNotification"
      />
      <div class="mt-4"></div>
      <div v-if="postLoading">
        <v-card class="pa-6 text-center"
          ><v-progress-circular indeterminate
        /></v-card>
      </div>
      <div v-else>
        <div v-for="item of posts" :key="item.id">
          <Post :item="item" :addComment="(data) => addPostComment(data)" :addLike="(data) => addPostLike(data)" />
        </div>

        <v-btn
          v-if="posts.length < totalPosts"
          color="primary"
          @click="lc_load_more"
          block
          >Load More</v-btn
        >
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ProfileCard from "../components/ProfileCard.vue";
import AddPost from "../components/AddPost.vue";
import Post from "../components/Post.vue";
export default {
  name: "Dashboard",
  components: {
    ProfileCard,
    AddPost,
    Post,
  },
  mounted() {
    let uid = this.authUser.id;
    this.getPosts([...this.authUser.connects, uid]);
    this.getTotalPosts(uid);
  },
  methods: {
    lc_load_more() {
      let uid = this.authUser.id;
      this.getMorePosts(uid);
    },
  },
};
</script>

<style scoped>
</style>
